<template>
  <div :class="$style[classes]">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" :labels="tableLabels" v-loading="loading" @select="select" @select-all="selectAll">
            <slot/>
          </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
import { saveSignTableLabels,IMMUNE_CELL_STORAGELabels } from '../save-sign-notes.js'
const prefixCls = 'pt-save-sign-table'

export default {
  name: 'pt-save-sign-notes-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 是否不需要显示“选择优惠”列
    noShowCouponLi () {
      return this.ruleActivityCode === 'NEWBORN_STEM_CELLS_STORAGE'
		},
		/*是否免疫细胞存储报名记录*/
		isIMMUNE_CELL_STORAGE(){
			return this.ruleActivityCode === 'IMMUNE_CELL_STORAGE'
		},
		/*免疫细胞存储报名记录表头*/
    tableLabels () {
      let labels = JSON.parse(JSON.stringify(saveSignTableLabels))
      labels.forEach((item, index) => {
        if (item.value === 'userOption.remark') {
          labels.splice(index, 1)
        }
      })
      return this.isIMMUNE_CELL_STORAGE?IMMUNE_CELL_STORAGELabels:(this.noShowCouponLi ? labels : saveSignTableLabels)
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: null
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    ruleActivityCode: String
  },
  data () {
    return {
      // tableLabels: saveSignTableLabels
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    select (row) {
      this.$emit('select', row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style  lang="less" module>
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-save-sign-table{
  :global
  .el-button{
    margin-left: 0;
    margin-right: 10px;
  }
}
</style>
